import React, { useMemo } from "react";
import { Box, Skeleton, Typography } from "@mui/material";

const WIDTH = "206px";
const HEIGHT = "100px";

export const PerformanceValue = ({
	name,
	colorTitle,
	value,
	units = "",
	containerStyle,
	notApplicable = false,
	loading,
}) => {
	const formattedValue = useMemo(() => {
		if (notApplicable && value === 0) {
			return "N/A";
		}

		return value?.toLocaleString();
	}, [notApplicable, value]);

	if (typeof value === "undefined") {
		return null;
	}

	if (loading) {
		return (
			<Skeleton
				variant="rounded"
				animation="wave"
				height={HEIGHT}
				width={WIDTH}
				sx={{ borderRadius: "20px", ...containerStyle }}
			/>
		);
	}

	return (
		<Box
			sx={{
				borderRadius: "20px",
				p: "16px",
				height: "100px",
				backgroundColor: "white.main",
				border: "1px solid #EFF0F6",
				minWidth: "206px",
				...containerStyle,
			}}
			boxShadow="0 4px 20px 0 rgba(0, 0, 0, 0.05)"
		>
			<Typography
				sx={{
					fontSize: 16,
					lineHeight: "19px",
					fontWeight: 500,
					color: colorTitle,
					mb: "10px",
				}}
			>
				{name}
			</Typography>
			<Typography
				sx={{
					fontFamily: "Inter",
					fontSize: 24,
					lineHeight: "29px",
					fontWeight: 700,
					color: "#2C2C2C",
				}}
			>
				{formattedValue}
				{notApplicable && value === 0 ? null : units ? (
					<Box sx={{ fontSize: 16, fontWeight: 500 }} component="span">
						{` ${units}`}
					</Box>
				) : null}
			</Typography>
		</Box>
	);
};
